var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-list',[_c('ion-item',{attrs:{"button":"true","detail":"false","color":"danger"},on:{"click":_vm.onDelete}},[_c('ion-icon',{attrs:{"slot":"start","name":"trash"},slot:"start"}),_c('span',[_vm._v("Delete")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }